export default __webpack_public_path__ + "static/media/negy.492338bd.jpg";